import { LoginPUBResponse } from '../../../../../types/api/endpoints/auth/login.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';
import { LoginPUBFormSchema } from './LoginPUBForm.types';

const PREFIX = '[loginPUBQuery]';

export const LOGIN_PUB_QUERY_KEY = 'LOGIN_PUB';

export const loginPUBQuery = async ({ email, password }: LoginPUBFormSchema) => {
  console.log(PREFIX, `Requesting PUB login...`);
  const response = await AUTH_ENDPOINTS.loginPUB({ email, password });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received PUB login response.`);
  return json as LoginPUBResponse;
};
